import customAxios from '../../customAxios';
import { ADMIN_REJECT_WITHDRAWAL_COMPANIES } from '../../routes';

const rejectPay2Company = async (_id: string, description?: string): Promise<any> => {
  try {return (await customAxios.put(
    ADMIN_REJECT_WITHDRAWAL_COMPANIES,
    {
      withdrawalId: _id,
      description : description,
    }
  )).data;
  } catch (error: unknown) {return console.error({ADMIN_REJECT_WITHDRAWAL_COMPANIES: error});}
};

export default rejectPay2Company;
